import { createActionGroup } from '@ngrx/store';

export const SocieteProfilActions = createActionGroup({
  source: 'Societe Profil',
  events: {}
});
